import React from "react";

const LoadingSpinner = () => {
  return (
    <div style={{
      height: "100vh",
      width: "100%",
      backgroundColor: "#FB8C00",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <div className="spinner" />
      <style>{`
        .spinner {
          width: 60px;
          height: 60px;
          border: 6px solid #fff;
          border-top: 6px solid #000;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
